module.exports = __webpack_public_path__ + "components/print-link/static/icon-print-58e18d550fe636efbe7618cf2c9e8853.svg";